module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"coupons":{"sub_title":"可用優惠券列表","expires_at":"有效期限至：{0}","unlimited":"有效期限：無期限"},"button":"查看我的優惠券","hint":"*根據優惠券到期時間的不同，可能會顯示已過期的優惠券。點擊「查看我的優惠券」按鈕可進行更準確的確認。"}}')
  delete Component.options._Ctor
}
